import { Stack } from "@mui/material";
import { Button, Dialog, Typography } from "@platform/design-system";

type ScenarioDetailsActionsNullifiedModalProps = {
  open: boolean;
  onClose: () => void;
  lines: string[];
};

export const ScenarioDetailsActionsNullifiedModal: React.FC<
  ScenarioDetailsActionsNullifiedModalProps
> = ({ open, onClose, lines }) => (
  <Dialog
    onClose={onClose}
    open={open}
    title="Some record(s) are not affected"
    maxWidth="xs"
    actions={
      <Button
        data-testid="modal-confirm-button"
        variant="tertiary"
        onClick={() => onClose()}
      >
        Ok
      </Button>
    }
    sx={{ "& .MuiDialogTitle-root": { fontWeight: 500 } }}
  >
    <Stack spacing={2} direction="column">
      {[...new Set(lines)].map((line) => (
        <Typography
          key={line}
          variant="body-large"
          sx={{ whiteSpace: "pre-line" }}
        >
          {line}
        </Typography>
      ))}
    </Stack>
  </Dialog>
);
